/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
import { codeLanguages } from 'code-snippets/constants';

const codeLanguageMappings = {
  curl: 'bash',
  node: 'javascript',
  [codeLanguages.consoleConsumer]: 'bash',
  [codeLanguages.kafkaJS]: 'javascript',
  [codeLanguages.noderdKafka]: 'javascript',
  [codeLanguages.kafkaPython]: 'python',
  [codeLanguages.kafkacat]: 'bash'
};

const codeLanguageDependencyMappings = {
  [codeLanguages.kafkaJS]: 'json', // package.json
  [codeLanguages.noderdKafka]: 'json', // package.json
  [codeLanguages.kafkaPython]: 'toml', // Pipfile
  [codeLanguages.java]: 'xml' // pom.xml
  // As there isn't an appropiate dependency file for kafkacat/kafka-console-consumer, they have been omitted here
};

// This function will return the highlight js mapping for the particular codeLanguage,
// or will return the codeLanguege passed in, if there is no mapping found.
export const getHighlightClassForCodeLanguage = (language) => {
  if (typeof language !== 'string') {
    return '';
  }
  return codeLanguageMappings[language] ? codeLanguageMappings[language] : language.toLowerCase();
};

// This function will return the highlight js mapping for the appropiate dependency file
// of the codeLanguage supplied, or will return the codeLanguage if no mapping found
export const getHighlightClassForDependencies = (language) => {
  if (typeof language !== 'string') {
    return '';
  }
  return codeLanguageDependencyMappings[language] ? codeLanguageDependencyMappings[language] : language.toLowerCase();
};
